var fn = function( obj ){
var __t,__p='';
__p+='\n'+
( require( "@/webgl/glsl/includes/glsl-compat.frag" )() )+
'\n\nuniform vec4 uColor;\n\nvoid main(void){\n\n  FragColor = uColor;\n  \n}';
return __p;
};
fn.toString=fn;
module.exports = fn;